import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import QuickActionMenu from '../../components/ui/QuickActionMenu';
import AddVehicleModal from './components/AddVehicleModal';

// Custom SVG Icons
const ElIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" fill="#F5A623" stroke="#F5A623" strokeWidth="1" strokeLinejoin="round"/>
  </svg>
);

const HybridIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M17 8C8 10 5.9 16.17 3.82 19.34a1 1 0 0 0 1.38 1.38C8.55 18.9 14.9 16.8 17 8z" fill="#2EC4A0" stroke="#2EC4A0" strokeWidth="1"/>
    <path d="M3 21l4-4" stroke="#2EC4A0" strokeWidth="2" strokeLinecap="square"/>
    <circle cx="17" cy="5" r="3" fill="none" stroke="#2EC4A0" strokeWidth="1.5"/>
  </svg>
);

const FuelIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="3" width="12" height="18" rx="1" stroke="#F5A623" strokeWidth="1.5"/>
    <path d="M7 8h4M7 12h4" stroke="#F5A623" strokeWidth="1.5" strokeLinecap="square"/>
    <path d="M15 6l4 2v8a1 1 0 0 1-1 1h-3" stroke="#F5A623" strokeWidth="1.5" strokeLinecap="square"/>
    <circle cx="18" cy="6" r="1.5" fill="#F5A623"/>
  </svg>
);

const MotoIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <circle cx="5" cy="16" r="3" stroke="#2EC4A0" strokeWidth="1.5"/>
    <circle cx="19" cy="16" r="3" stroke="#2EC4A0" strokeWidth="1.5"/>
    <path d="M8 16h8M10 16l3-7h3l2 4" stroke="#2EC4A0" strokeWidth="1.5" strokeLinecap="square"/>
    <path d="M13 9l-2-3H8" stroke="#2EC4A0" strokeWidth="1.5" strokeLinecap="square"/>
  </svg>
);

const TruckIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <rect x="1" y="6" width="14" height="11" rx="1" stroke="#F5A623" strokeWidth="1.5"/>
    <path d="M15 9h4l3 4v4h-7V9z" stroke="#F5A623" strokeWidth="1.5" strokeLinejoin="round"/>
    <circle cx="5.5" cy="18.5" r="2" stroke="#F5A623" strokeWidth="1.5"/>
    <circle cx="18.5" cy="18.5" r="2" stroke="#F5A623" strokeWidth="1.5"/>
  </svg>
);

const CalcIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="3" width="18" height="18" rx="1" stroke="currentColor" strokeWidth="2"/>
    <rect x="6" y="6" width="12" height="4" fill="currentColor" opacity="0.3"/>
    <circle cx="7" cy="14" r="1.5" fill="currentColor"/>
    <circle cx="12" cy="14" r="1.5" fill="currentColor"/>
    <circle cx="17" cy="14" r="1.5" fill="currentColor"/>
    <circle cx="7" cy="18" r="1.5" fill="currentColor"/>
    <circle cx="12" cy="18" r="1.5" fill="currentColor"/>
    <rect x="15" y="16.5" width="4" height="3" rx="0.5" fill="currentColor"/>
  </svg>
);

const SwapIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <path d="M7 16V4m0 0L3 8m4-4l4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="square"/>
    <path d="M17 8v12m0 0l4-4m-4 4l-4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="square"/>
  </svg>
);

const CheckIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
    <polyline points="20 6 9 17 4 12" stroke="#2EC4A0" strokeWidth="2.5" strokeLinecap="square"/>
  </svg>
);

const WarnIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="#e74c3c" strokeWidth="1.5"/>
    <line x1="12" y1="9" x2="12" y2="13" stroke="#e74c3c" strokeWidth="2" strokeLinecap="square"/>
    <circle cx="12" cy="17" r="1" fill="#e74c3c"/>
  </svg>
);

const TollGateIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <rect x="2" y="10" width="20" height="3" fill="currentColor" opacity="0.4"/>
    <rect x="5" y="3" width="2" height="7" fill="currentColor"/>
    <rect x="17" y="3" width="2" height="7" fill="currentColor"/>
    <rect x="5" y="13" width="2" height="8" fill="currentColor"/>
    <rect x="17" y="13" width="2" height="8" fill="currentColor"/>
    <path d="M7 11.5h10" stroke="#F5A623" strokeWidth="1.5" strokeLinecap="square" strokeDasharray="2 2"/>
  </svg>
);

const RouteIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <circle cx="6" cy="6" r="3" stroke="#2EC4A0" strokeWidth="1.5"/>
    <circle cx="18" cy="18" r="3" stroke="#F5A623" strokeWidth="1.5"/>
    <path d="M6 9c0 6 12 6 12 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeDasharray="3 2"/>
  </svg>
);

const TollCalculator = () => {
  const [origin, setOrigin] = useState('');
  const [destination, setDestination] = useState('');
  const [departureDate, setDepartureDate] = useState('');
  const [departureTime, setDepartureTime] = useState('');
  const [selectedVehicleType, setSelectedVehicleType] = useState('el');
  const [isCalculating, setIsCalculating] = useState(false);
  const [results, setResults] = useState(null);
  const [errors, setErrors] = useState({});
  const [isAddVehicleModalOpen, setIsAddVehicleModalOpen] = useState(false);

  const vehicleTypes = [
    { id: 'el', label: 'Elbil', Icon: ElIcon, discount: 50, color: '#F5A623', desc: '50% rabatt' },
    { id: 'hybrid', label: 'Hybrid', Icon: HybridIcon, discount: 20, color: '#2EC4A0', desc: '20% rabatt' },
    { id: 'bensin', label: 'Bensin', Icon: FuelIcon, discount: 0, color: '#F5A623', desc: 'Full pris' },
    { id: 'mc', label: 'MC', Icon: MotoIcon, discount: 50, color: '#2EC4A0', desc: '50% rabatt' },
    { id: 'tung', label: 'Tung', Icon: TruckIcon, discount: 0, color: '#F5A623', desc: 'Tillegg' }
  ];

  const popularRoutes = [
    { from: 'Oslo', to: 'Bergen', km: 465, img: "https://img.rocket.new/generatedImages/rocket_gen_img_1984f193a-1772187198512.png", alt: 'Fjordvei mellom Oslo og Bergen med snødekte fjell' },
    { from: 'Oslo', to: 'Trondheim', km: 494, img: "https://img.rocket.new/generatedImages/rocket_gen_img_17ba1ee75-1772187199296.png", alt: 'E6 motorvei mot Trondheim gjennom norsk vinterlandskap' },
    { from: 'Stavanger', to: 'Kristiansand', km: 248, img: "https://img.rocket.new/generatedImages/rocket_gen_img_16db2fef8-1772187200459.png", alt: 'Kystveien mellom Stavanger og Kristiansand' },
    { from: 'Bergen', to: 'Ålesund', km: 310, img: "https://img.rocket.new/generatedImages/rocket_gen_img_1db1730d0-1772187199340.png", alt: 'Vestlandsfjord med bratte fjell og smale veier' }
  ];

  const validate = () => {
    const e = {};
    if (!origin?.trim()) e.origin = 'Angi startsted';
    if (!destination?.trim()) e.destination = 'Angi destinasjon';
    if (!departureDate) e.departureDate = 'Velg dato';
    if (!departureTime) e.departureTime = 'Velg tid';
    setErrors(e);
    return Object.keys(e)?.length === 0;
  };

  const handleCalculate = (e) => {
    e?.preventDefault();
    if (!validate()) return;
    setIsCalculating(true);
    setTimeout(() => {
      const vt = vehicleTypes?.find((v) => v?.id === selectedVehicleType);
      const baseCost = 3600;
      const discount = baseCost * (vt?.discount / 100);
      const total = baseCost - discount;
      const isRush = departureTime >= '06:30' && departureTime <= '09:00';
      setResults({
        total, baseCost, discount,
        discountLabel: vt?.discount > 0 ? `${vt?.label} ${vt?.discount}% rabatt` : null,
        distance: 465, duration: 420, isRush, vehicle: vt,
        tollPoints: [
          { name: 'Oslo Vest', road: 'E18 Lysaker', cost: Math.round(45 * (1 - vt?.discount / 100)), rush: isRush },
          { name: 'Drammen Bomring', road: 'E18 Drammen', cost: Math.round(55 * (1 - vt?.discount / 100)), rush: isRush },
          { name: 'Sande', road: 'E18 Sande', cost: Math.round(35 * (1 - vt?.discount / 100)), rush: false },
          { name: 'Holmestrand', road: 'E18 Holmestrand', cost: Math.round(40 * (1 - vt?.discount / 100)), rush: false },
          { name: 'Tønsberg Bomring', road: 'E18 Tønsberg', cost: Math.round(48 * (1 - vt?.discount / 100)), rush: false },
          { name: 'Sandefjord', road: 'E18 Sandefjord', cost: Math.round(44 * (1 - vt?.discount / 100)), rush: false },
          { name: 'Porsgrunn', road: 'E18 Porsgrunn', cost: Math.round(52 * (1 - vt?.discount / 100)), rush: false },
          { name: 'Kristiansand Bomring', road: 'E18 Kristiansand', cost: Math.round(60 * (1 - vt?.discount / 100)), rush: false }
        ],
        alternatives: [
          { name: 'Via E39 Kystveien', km: 485, time: '7t 30min', cost: Math.round(total * 0.72), savings: Math.round(total * 0.28) },
          { name: 'Via Rv9 Innlandet', km: 520, time: '8t 0min', cost: Math.round(total * 0.55), savings: Math.round(total * 0.45) }
        ]
      });
      setIsCalculating(false);
    }, 1800);
  };

  const fmt = (n) => new Intl.NumberFormat('nb-NO', { style: 'currency', currency: 'NOK', minimumFractionDigits: 0 })?.format(n);
  const fmtTime = (min) => { const h = Math.floor(min / 60); const m = min % 60; return h > 0 ? `${h}t ${m}min` : `${m}min`; };

  const selectedVT = vehicleTypes?.find(v => v?.id === selectedVehicleType);

  return (
    <>
      <Helmet>
        <title>Bomkalkulator — NordPass</title>
        <meta name="description" content="Beregn nøyaktige bompengekostnader for dine reiser i Norge." />
      </Helmet>
      <div style={{ minHeight: '100vh', background: '#0A0C10', color: '#f0f0f0', fontFamily: 'system-ui, sans-serif' }}>
        <Header />

        {/* ── HERO ── */}
        <div style={{ position: 'relative', height: 380, overflow: 'hidden' }}>
          <img
            src="https://img.rocket.new/generatedImages/rocket_gen_img_1e4d6cbcf-1772187199695.png"
            alt="Norsk motorvei med bomstasjon og fjordlandskap i bakgrunnen"
            style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 60%', filter: 'brightness(0.7) contrast(1.1)' }}
          />
          {/* Diagonal color-block overlay */}
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(105deg, rgba(10,12,16,0.97) 38%, rgba(10,12,16,0.55) 65%, transparent 100%)' }} />
          {/* Orange accent stripe — diagonal */}
          <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '4px', background: 'linear-gradient(90deg, #F5A623 0%, #2EC4A0 60%, transparent 100%)' }} />
          {/* Ghost watermark */}
          <div style={{ position: 'absolute', right: -20, bottom: -30, fontSize: 'clamp(120px,18vw,220px)', fontFamily: 'Impact, Haettenschweiler, sans-serif', fontWeight: 900, color: 'rgba(245,166,35,0.04)', lineHeight: 1, userSelect: 'none', letterSpacing: -8 }}>BOM</div>

          <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', padding: '0 48px' }}>
            <div style={{ maxWidth: 580 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
                <div style={{ width: 3, height: 28, background: '#F5A623' }} />
                <span style={{ fontSize: 10, letterSpacing: 4, textTransform: 'uppercase', color: '#F5A623', fontWeight: 800 }}>Bomkalkulator · NordPass</span>
              </div>
              <h1 style={{ fontSize: 'clamp(36px,5vw,64px)', fontFamily: 'Impact, Haettenschweiler, "Arial Narrow", sans-serif', fontWeight: 900, lineHeight: 0.95, margin: '0 0 18px', letterSpacing: -2, textTransform: 'uppercase' }}>
                Beregn<br />
                <span style={{ color: '#F5A623' }}>Bom</span>kostnader
              </h1>
              <p style={{ fontSize: 15, color: '#9aa', lineHeight: 1.65, margin: '0 0 28px', fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>
                Nøyaktige bompengekostnader for alle norske veier — med EL-rabatter, rushtidspriser og alternative ruter.
              </p>
              {/* Editorial stat pills */}
              <div style={{ display: 'flex', gap: 0, flexWrap: 'wrap' }}>
                {[['⚡', 'Elbil', '50% rabatt', '#F5A623'], ['🔋', 'Hybrid', '20% rabatt', '#2EC4A0'], ['🕐', 'Rushtid', 'Automatisk', '#F5A623']]?.map(([icon, label, sub, col], i) =>
                  <div key={i} style={{ background: i % 2 === 0 ? 'rgba(245,166,35,0.08)' : 'rgba(46,196,160,0.08)', border: `1px solid ${col}30`, borderRight: i < 2 ? 'none' : undefined, padding: '10px 18px' }}>
                    <div style={{ fontSize: 12, fontWeight: 800, color: col, fontFamily: 'Impact, sans-serif', letterSpacing: 1 }}>{icon} {label}</div>
                    <div style={{ fontSize: 10, color: '#666', marginTop: 2 }}>{sub}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div style={{ maxWidth: 1400, margin: '0 auto', padding: '0 24px' }}>

          {/* ── POPULAR ROUTES — editorial mosaic ── */}
          <section style={{ padding: '44px 0 0' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18 }}>
              <RouteIcon />
              <span style={{ fontSize: 10, color: '#666', textTransform: 'uppercase', letterSpacing: 3, fontWeight: 700 }}>Populære ruter</span>
              <div style={{ flex: 1, height: 1, background: 'repeating-linear-gradient(90deg, rgba(245,166,35,0.3) 0px, rgba(245,166,35,0.3) 4px, transparent 4px, transparent 10px)' }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 3 }}>
              {popularRoutes?.map((r, i) =>
                <div
                  key={i}
                  onClick={() => { setOrigin(r?.from); setDestination(r?.to); setErrors({}); }}
                  style={{ position: 'relative', overflow: 'hidden', cursor: 'pointer', height: 150,
                    clipPath: i === 0 ? 'polygon(0 0, 100% 0, 95% 100%, 0 100%)' : i === 3 ? 'polygon(5% 0, 100% 0, 100% 100%, 0 100%)' : undefined
                  }}
                >
                  <img src={r?.img} alt={r?.alt} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.4s', filter: 'brightness(0.75) contrast(1.1)' }} />
                  <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.1) 60%)' }} />
                  {/* Orange accent on hover */}
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 3, background: i % 2 === 0 ? '#F5A623' : '#2EC4A0' }} />
                  <div style={{ position: 'absolute', bottom: 14, left: 12, right: 12 }}>
                    <div style={{ fontSize: 13, fontWeight: 900, fontFamily: 'Impact, Haettenschweiler, sans-serif', letterSpacing: 0.5, textTransform: 'uppercase' }}>{r?.from} → {r?.to}</div>
                    <div style={{ fontSize: 10, color: '#aaa', marginTop: 2 }}>{r?.km} km</div>
                  </div>
                  <div style={{ position: 'absolute', top: 10, right: 10, background: i % 2 === 0 ? '#F5A623' : '#2EC4A0', color: '#0A0C10', fontSize: 9, fontWeight: 900, padding: '2px 6px', fontFamily: 'Impact, sans-serif', letterSpacing: 1 }}>VELG</div>
                </div>
              )}
            </div>
          </section>

          {/* ── TORN PAPER DIVIDER ── */}
          <div style={{ margin: '36px 0 0', position: 'relative', height: 20, overflow: 'hidden' }}>
            <svg viewBox="0 0 1200 20" preserveAspectRatio="none" style={{ width: '100%', height: '100%' }}>
              <path d="M0,10 C80,2 160,18 240,8 C320,-2 400,16 480,6 C560,-4 640,18 720,10 C800,2 880,14 960,6 C1040,-4 1120,16 1200,10" fill="rgba(46,196,160,0.06)"/>
              <path d="M0,14 C80,6 160,20 240,12 C320,4 400,18 480,10 C560,2 640,16 720,8 C800,0 880,14 960,6 C1040,-2 1120,16 1200,10" fill="none" stroke="rgba(46,196,160,0.15)" strokeWidth="1"/>
            </svg>
          </div>

          {/* ── MAIN CALCULATOR — asymmetric grid ── */}
          <section style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 3, padding: '8px 0 0', alignItems: 'start' }}>

            {/* LEFT: Form — dark editorial panel */}
            <div style={{ background: '#111520', border: '1px solid rgba(245,166,35,0.12)', borderRight: 'none', position: 'relative', overflow: 'hidden' }}>
              {/* Ghost number watermark */}
              <div style={{ position: 'absolute', top: -20, right: -10, fontSize: 160, fontFamily: 'Impact, sans-serif', fontWeight: 900, color: 'rgba(245,166,35,0.03)', lineHeight: 1, userSelect: 'none', pointerEvents: 'none' }}>01</div>

              {/* Section header — color blocked */}
              <div style={{ background: 'linear-gradient(90deg, #F5A623 0%, rgba(245,166,35,0.6) 60%, transparent 100%)', padding: '14px 28px', display: 'flex', alignItems: 'center', gap: 12 }}>
                <CalcIcon />
                <span style={{ fontFamily: 'Impact, Haettenschweiler, sans-serif', fontSize: 15, fontWeight: 900, color: '#0A0C10', letterSpacing: 2, textTransform: 'uppercase' }}>Rutedetaljer</span>
              </div>

              <div style={{ padding: '28px 28px 32px' }}>

                {/* ── VEHICLE SELECTOR — polaroid-style cards ── */}
                <div style={{ marginBottom: 28 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
                    <div style={{ width: 2, height: 14, background: '#2EC4A0' }} />
                    <span style={{ fontSize: 9, color: '#2EC4A0', textTransform: 'uppercase', letterSpacing: 3, fontWeight: 800 }}>Kjøretøytype</span>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 6 }}>
                    {vehicleTypes?.map((v, idx) => {
                      const isSelected = selectedVehicleType === v?.id;
                      const rotations = [-1.2, 0.8, -0.5, 1.0, -0.7];
                      const rot = rotations?.[idx % rotations?.length];
                      return (
                        <button
                          key={v?.id}
                          onClick={() => setSelectedVehicleType(v?.id)}
                          style={{
                            padding: '10px 6px 14px',
                            background: isSelected ? '#EEF0F2' : '#1a1d28',
                            border: `2px solid ${isSelected ? v?.color : 'rgba(255,255,255,0.06)'}`,
                            cursor: 'pointer',
                            textAlign: 'center',
                            transform: isSelected ? 'rotate(0deg) translateY(-4px)' : `rotate(${rot}deg)`,
                            boxShadow: isSelected
                              ? `4px 4px 0 ${v?.color}60, 0 8px 20px rgba(0,0,0,0.5)`
                              : '2px 2px 0 rgba(0,0,0,0.4)',
                            transition: 'all 250ms cubic-bezier(0.34,1.56,0.64,1)',
                            position: 'relative',
                            zIndex: isSelected ? 2 : 1
                          }}
                        >
                          {/* Tape corner */}
                          <div style={{ position: 'absolute', top: -4, left: '50%', transform: 'translateX(-50%)', width: 24, height: 8, background: isSelected ? `${v?.color}80` : 'rgba(255,255,255,0.1)', opacity: 0.8 }} />
                          <div style={{ marginBottom: 6, display: 'flex', justifyContent: 'center' }}>
                            <v.Icon />
                          </div>
                          <div style={{ fontSize: 9, fontWeight: 900, fontFamily: 'Impact, Haettenschweiler, sans-serif', color: isSelected ? '#0A0C10' : '#ccc', letterSpacing: 0.5, textTransform: 'uppercase' }}>{v?.label}</div>
                          <div style={{ fontSize: 8, color: isSelected ? v?.color : '#555', marginTop: 2, fontWeight: 700 }}>{v?.desc}</div>
                        </button>
                      );
                    })}
                  </div>
                </div>

                <form onSubmit={handleCalculate}>
                  {/* Route inputs */}
                  <div style={{ marginBottom: 20 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                      <div style={{ width: 2, height: 14, background: '#F5A623' }} />
                      <span style={{ fontSize: 9, color: '#F5A623', textTransform: 'uppercase', letterSpacing: 3, fontWeight: 800 }}>Rute</span>
                    </div>
                    <div style={{ position: 'relative', marginBottom: 8 }}>
                      <div style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', width: 8, height: 8, background: '#2EC4A0', clipPath: 'polygon(50% 0%, 100% 100%, 0% 100%)', zIndex: 1 }} />
                      <input
                        type="text"
                        placeholder="Fra — f.eks. Oslo"
                        value={origin}
                        onChange={(e) => { setOrigin(e?.target?.value); setErrors((p) => ({ ...p, origin: '' })); }}
                        style={{
                          width: '100%', padding: '12px 14px 12px 34px', background: 'rgba(255,255,255,0.04)',
                          border: `1px solid ${errors?.origin ? '#e74c3c' : 'rgba(245,166,35,0.15)'}`,
                          color: '#f0f0f0', fontSize: 14, outline: 'none', boxSizing: 'border-box',
                          fontFamily: 'Georgia, serif'
                        }}
                      />
                      {errors?.origin && <div style={{ fontSize: 10, color: '#e74c3c', marginTop: 4, display: 'flex', alignItems: 'center', gap: 4 }}><WarnIcon />{errors?.origin}</div>}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', margin: '4px 0' }}>
                      <button
                        type="button"
                        onClick={() => { const t = origin; setOrigin(destination); setDestination(t); }}
                        style={{ background: 'rgba(245,166,35,0.1)', border: '1px solid rgba(245,166,35,0.25)', padding: '5px 14px', cursor: 'pointer', color: '#F5A623', fontSize: 11, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 6, fontFamily: 'Impact, sans-serif', letterSpacing: 1 }}
                      >
                        <SwapIcon /> BYTT
                      </button>
                    </div>
                    <div style={{ position: 'relative' }}>
                      <div style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', width: 8, height: 8, background: '#F5A623', zIndex: 1 }} />
                      <input
                        type="text"
                        placeholder="Til — f.eks. Bergen"
                        value={destination}
                        onChange={(e) => { setDestination(e?.target?.value); setErrors((p) => ({ ...p, destination: '' })); }}
                        style={{
                          width: '100%', padding: '12px 14px 12px 34px', background: 'rgba(255,255,255,0.04)',
                          border: `1px solid ${errors?.destination ? '#e74c3c' : 'rgba(245,166,35,0.15)'}`,
                          color: '#f0f0f0', fontSize: 14, outline: 'none', boxSizing: 'border-box',
                          fontFamily: 'Georgia, serif'
                        }}
                      />
                      {errors?.destination && <div style={{ fontSize: 10, color: '#e74c3c', marginTop: 4, display: 'flex', alignItems: 'center', gap: 4 }}><WarnIcon />{errors?.destination}</div>}
                    </div>
                  </div>

                  {/* Date + Time */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 24 }}>
                    <div>
                      <div style={{ fontSize: 9, color: '#888', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 8, fontWeight: 700 }}>Dato</div>
                      <input
                        type="date"
                        value={departureDate}
                        onChange={(e) => { setDepartureDate(e?.target?.value); setErrors((p) => ({ ...p, departureDate: '' })); }}
                        min={new Date()?.toISOString()?.split('T')?.[0]}
                        style={{
                          width: '100%', padding: '11px 12px', background: 'rgba(255,255,255,0.04)',
                          border: `1px solid ${errors?.departureDate ? '#e74c3c' : 'rgba(245,166,35,0.15)'}`,
                          color: '#f0f0f0', fontSize: 13, outline: 'none', boxSizing: 'border-box', colorScheme: 'dark'
                        }}
                      />
                      {errors?.departureDate && <div style={{ fontSize: 10, color: '#e74c3c', marginTop: 4 }}>{errors?.departureDate}</div>}
                    </div>
                    <div>
                      <div style={{ fontSize: 9, color: '#888', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 8, fontWeight: 700 }}>Tidspunkt</div>
                      <input
                        type="time"
                        value={departureTime}
                        onChange={(e) => { setDepartureTime(e?.target?.value); setErrors((p) => ({ ...p, departureTime: '' })); }}
                        style={{
                          width: '100%', padding: '11px 12px', background: 'rgba(255,255,255,0.04)',
                          border: `1px solid ${errors?.departureTime ? '#e74c3c' : 'rgba(245,166,35,0.15)'}`,
                          color: '#f0f0f0', fontSize: 13, outline: 'none', boxSizing: 'border-box', colorScheme: 'dark'
                        }}
                      />
                      {errors?.departureTime && <div style={{ fontSize: 10, color: '#e74c3c', marginTop: 4 }}>{errors?.departureTime}</div>}
                    </div>
                  </div>

                  {/* Submit — editorial CTA */}
                  <button
                    type="submit"
                    disabled={isCalculating}
                    style={{
                      width: '100%', padding: '16px', background: isCalculating ? '#1a1d28' : '#F5A623',
                      border: 'none', color: isCalculating ? '#555' : '#0A0C10',
                      fontSize: 14, fontWeight: 900, cursor: isCalculating ? 'not-allowed' : 'pointer',
                      letterSpacing: 2, fontFamily: 'Impact, Haettenschweiler, sans-serif',
                      textTransform: 'uppercase', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
                      clipPath: 'polygon(0 0, calc(100% - 12px) 0, 100% 100%, 12px 100%)',
                      transition: 'all 0.2s',
                      boxShadow: isCalculating ? 'none' : '4px 4px 0 rgba(245,166,35,0.3)'
                    }}
                  >
                    <CalcIcon />
                    {isCalculating ? 'Beregner...' : 'Beregn Bompenger'}
                  </button>
                </form>

                {/* Rush hour info */}
                <div style={{ marginTop: 18, padding: '12px 16px', background: 'rgba(245,166,35,0.05)', borderLeft: '3px solid #F5A623' }}>
                  <div style={{ fontSize: 11, fontWeight: 800, color: '#F5A623', marginBottom: 4, fontFamily: 'Impact, sans-serif', letterSpacing: 1 }}>RUSHTIDSPRISER</div>
                  <div style={{ fontSize: 11, color: '#777', lineHeight: 1.6 }}>Høyere takster gjelder 06:30–09:00 og 15:00–17:00 på hverdager i byområder.</div>
                </div>
              </div>
            </div>

            {/* RIGHT: Results — teal-accented panel */}
            <div style={{ background: '#0e1118', border: '1px solid rgba(46,196,160,0.12)', position: 'relative', overflow: 'hidden', minHeight: 600 }}>
              {/* Ghost number watermark */}
              <div style={{ position: 'absolute', top: -20, right: -10, fontSize: 160, fontFamily: 'Impact, sans-serif', fontWeight: 900, color: 'rgba(46,196,160,0.03)', lineHeight: 1, userSelect: 'none', pointerEvents: 'none' }}>02</div>

              {/* Section header */}
              <div style={{ background: 'linear-gradient(90deg, #2EC4A0 0%, rgba(46,196,160,0.5) 60%, transparent 100%)', padding: '14px 28px', display: 'flex', alignItems: 'center', gap: 12 }}>
                <TollGateIcon />
                <span style={{ fontFamily: 'Impact, Haettenschweiler, sans-serif', fontSize: 15, fontWeight: 900, color: '#0A0C10', letterSpacing: 2, textTransform: 'uppercase' }}>Resultat</span>
              </div>

              <div style={{ padding: '28px' }}>
                {!results && !isCalculating &&
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '20px 20px 0' }}>
                    <div style={{ position: 'relative', width: '100%', height: 260, overflow: 'hidden', marginBottom: 24 }}>
                      <img
                        src="https://images.unsplash.com/photo-1655713053602-1d283b2a268f"
                        alt="Norsk fjordvei med serpentiner og snødekte fjell i bakgrunnen"
                        style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'brightness(0.6) contrast(1.1)' }}
                      />
                      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(14,17,24,0.95) 0%, rgba(14,17,24,0.2) 60%)' }} />
                      {/* Polaroid tape */}
                      <div style={{ position: 'absolute', top: 12, left: '50%', transform: 'translateX(-50%)', width: 60, height: 12, background: 'rgba(245,166,35,0.3)', opacity: 0.8 }} />
                      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '16px 20px', textAlign: 'left' }}>
                        <div style={{ fontFamily: 'Impact, Haettenschweiler, sans-serif', fontSize: 28, fontWeight: 900, color: '#fff', letterSpacing: -1, textTransform: 'uppercase', lineHeight: 1 }}>Klar til å<br /><span style={{ color: '#F5A623' }}>beregne</span></div>
                      </div>
                    </div>
                    <p style={{ fontSize: 13, color: '#666', lineHeight: 1.7, fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>Fyll inn rute og kjøretøytype til venstre, så viser vi deg nøyaktige bompengekostnader med alle rabatter.</p>
                  </div>
                }

                {isCalculating &&
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 20, padding: '60px 20px' }}>
                    <div style={{ width: 60, height: 60, border: '3px solid rgba(245,166,35,0.2)', borderTop: '3px solid #F5A623', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
                    <div style={{ fontFamily: 'Impact, Haettenschweiler, sans-serif', fontSize: 18, fontWeight: 900, letterSpacing: 2, textTransform: 'uppercase', color: '#F5A623' }}>Beregner...</div>
                    <div style={{ width: 200, height: 3, background: 'rgba(255,255,255,0.06)' }}>
                      <div style={{ height: '100%', background: 'linear-gradient(90deg, #F5A623, #2EC4A0)', animation: 'slideIn 1.8s ease-in-out' }} />
                    </div>
                    <p style={{ fontSize: 11, color: '#555', fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>Henter takster fra alle bomstasjoner...</p>
                  </div>
                }

                {results && !isCalculating &&
                  <div>
                    {/* Route visual */}
                    <div style={{ position: 'relative', overflow: 'hidden', marginBottom: 16 }}>
                      <img
                        src="https://img.rocket.new/generatedImages/rocket_gen_img_1a60d584c-1772187200115.png"
                        alt="Norsk motorvei med bomstasjon og fjordlandskap"
                        style={{ width: '100%', height: 110, objectFit: 'cover', display: 'block', filter: 'brightness(0.6) contrast(1.1)' }}
                      />
                      <div style={{ position: 'absolute', inset: 0, background: 'rgba(14,17,24,0.6)' }} />
                      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 3, background: 'linear-gradient(90deg, #F5A623, #2EC4A0)' }} />
                      <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 20px' }}>
                        <div style={{ textAlign: 'center' }}>
                          <div style={{ fontSize: 9, color: '#2EC4A0', marginBottom: 4, fontWeight: 800, letterSpacing: 2 }}>FRA</div>
                          <div style={{ fontSize: 16, fontWeight: 900, fontFamily: 'Impact, sans-serif', textTransform: 'uppercase' }}>{origin}</div>
                        </div>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '0 16px' }}>
                          <div style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.2)', position: 'relative' }}>
                            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', background: '#F5A623', padding: '3px 8px', fontSize: 9, fontWeight: 900, color: '#0A0C10', whiteSpace: 'nowrap', fontFamily: 'Impact, sans-serif', letterSpacing: 1 }}>
                              {results?.distance} KM
                            </div>
                          </div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                          <div style={{ fontSize: 9, color: '#F5A623', marginBottom: 4, fontWeight: 800, letterSpacing: 2 }}>TIL</div>
                          <div style={{ fontSize: 16, fontWeight: 900, fontFamily: 'Impact, sans-serif', textTransform: 'uppercase' }}>{destination}</div>
                        </div>
                      </div>
                    </div>

                    {/* Cost summary — color-blocked */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 3, marginBottom: 14 }}>
                      <div style={{ background: '#F5A623', padding: '14px 12px', gridColumn: '1 / 2', clipPath: 'polygon(0 0, 100% 0, 95% 100%, 0 100%)' }}>
                        <div style={{ fontSize: 9, color: '#0A0C10', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4, fontWeight: 800 }}>Total bom</div>
                        <div style={{ fontSize: 24, fontWeight: 900, color: '#0A0C10', fontFamily: 'Impact, Haettenschweiler, sans-serif' }}>{fmt(results?.total)}</div>
                      </div>
                      <div style={{ background: 'rgba(46,196,160,0.08)', border: '1px solid rgba(46,196,160,0.2)', padding: '14px 12px' }}>
                        <div style={{ fontSize: 9, color: '#888', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4, fontWeight: 700 }}>Avstand</div>
                        <div style={{ fontSize: 20, fontWeight: 900, fontFamily: 'Impact, sans-serif' }}>{results?.distance}<span style={{ fontSize: 11, color: '#666', marginLeft: 3 }}>km</span></div>
                      </div>
                      <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', padding: '14px 12px' }}>
                        <div style={{ fontSize: 9, color: '#888', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4, fontWeight: 700 }}>Reisetid</div>
                        <div style={{ fontSize: 18, fontWeight: 900, fontFamily: 'Impact, sans-serif' }}>{fmtTime(results?.duration)}</div>
                      </div>
                    </div>

                    {results?.discount > 0 &&
                      <div style={{ background: 'rgba(46,196,160,0.08)', borderLeft: '3px solid #2EC4A0', padding: '10px 14px', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <CheckIcon />
                        <div>
                          <div style={{ fontSize: 12, fontWeight: 800, color: '#2EC4A0', fontFamily: 'Impact, sans-serif', letterSpacing: 1 }}>{results?.discountLabel?.toUpperCase()} ANVENDT</div>
                          <div style={{ fontSize: 10, color: '#666' }}>Du sparer {fmt(results?.discount)} — opprinnelig {fmt(results?.baseCost)}</div>
                        </div>
                      </div>
                    }

                    {results?.isRush &&
                      <div style={{ background: 'rgba(231,76,60,0.08)', borderLeft: '3px solid #e74c3c', padding: '10px 14px', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <WarnIcon />
                        <div>
                          <div style={{ fontSize: 12, fontWeight: 800, color: '#e74c3c', fontFamily: 'Impact, sans-serif', letterSpacing: 1 }}>RUSHTIDSPRISER GJELDER</div>
                          <div style={{ fontSize: 10, color: '#666' }}>Avreise i rushtiden — høyere takster på utvalgte stasjoner</div>
                        </div>
                      </div>
                    }

                    {/* Toll points */}
                    <div style={{ marginBottom: 14 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                        <TollGateIcon />
                        <span style={{ fontSize: 9, color: '#F5A623', textTransform: 'uppercase', letterSpacing: 3, fontWeight: 800 }}>Bomstasjoner ({results?.tollPoints?.length})</span>
                      </div>
                      <div style={{ maxHeight: 200, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {results?.tollPoints?.map((tp, i) =>
                          <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 12px', background: i % 2 === 0 ? 'rgba(245,166,35,0.03)' : 'rgba(46,196,160,0.03)', borderLeft: `2px solid ${i % 2 === 0 ? 'rgba(245,166,35,0.2)' : 'rgba(46,196,160,0.2)'}` }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                              <div style={{ width: 20, height: 20, background: i % 2 === 0 ? '#F5A623' : '#2EC4A0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, fontWeight: 900, color: '#0A0C10', fontFamily: 'Impact, sans-serif', flexShrink: 0 }}>{i + 1}</div>
                              <div>
                                <div style={{ fontSize: 12, fontWeight: 700 }}>{tp?.name}</div>
                                <div style={{ fontSize: 9, color: '#555' }}>{tp?.road}</div>
                              </div>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                              <div style={{ fontSize: 13, fontWeight: 900, fontFamily: 'Impact, sans-serif', color: i % 2 === 0 ? '#F5A623' : '#2EC4A0' }}>{fmt(tp?.cost)}</div>
                              {tp?.rush && <div style={{ fontSize: 8, color: '#e74c3c', fontWeight: 800, letterSpacing: 1 }}>RUSHTID</div>}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Alternative routes */}
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                        <RouteIcon />
                        <span style={{ fontSize: 9, color: '#2EC4A0', textTransform: 'uppercase', letterSpacing: 3, fontWeight: 800 }}>Alternative ruter</span>
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        {results?.alternatives?.map((alt, i) =>
                          <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px', background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)', cursor: 'pointer', borderLeft: `3px solid ${i === 0 ? '#F5A623' : '#2EC4A0'}` }}>
                            <div>
                              <div style={{ fontSize: 12, fontWeight: 800, fontFamily: 'Impact, sans-serif', letterSpacing: 0.5 }}>{alt?.name}</div>
                              <div style={{ fontSize: 10, color: '#666' }}>{alt?.km} km · {alt?.time}</div>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                              <div style={{ fontSize: 14, fontWeight: 900, fontFamily: 'Impact, sans-serif' }}>{fmt(alt?.cost)}</div>
                              <div style={{ fontSize: 10, color: '#2EC4A0', fontWeight: 700 }}>Spar {fmt(alt?.savings)}</div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </section>

          {/* ── TORN PAPER DIVIDER 2 ── */}
          <div style={{ margin: '36px 0 0', position: 'relative', height: 20, overflow: 'hidden' }}>
            <svg viewBox="0 0 1200 20" preserveAspectRatio="none" style={{ width: '100%', height: '100%' }}>
              <path d="M0,10 C80,2 160,18 240,8 C320,-2 400,16 480,6 C560,-4 640,18 720,10 C800,2 880,14 960,6 C1040,-4 1120,16 1200,10" fill="rgba(46,196,160,0.06)"/>
              <path d="M0,14 C80,6 160,20 240,12 C320,4 400,18 480,10 C560,2 640,16 720,8 C800,0 880,14 960,6 C1040,-2 1120,16 1200,10" fill="none" stroke="rgba(46,196,160,0.15)" strokeWidth="1"/>
            </svg>
          </div>

          {/* ── INFO STRIP ── */}
          <section style={{ padding: '8px 0 52px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 3 }}>
              <div style={{ position: 'relative', overflow: 'hidden', clipPath: 'polygon(0 0, 100% 0, 95% 100%, 0 100%)' }}>
                <img
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_1ddf4877a-1772187199936.png"
                  alt="Norsk bomstasjon med AutoPASS-brikke og betalingssystem"
                  style={{ width: '100%', height: 220, objectFit: 'cover', display: 'block', filter: 'brightness(0.65) contrast(1.1)' }}
                />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to right, rgba(10,12,16,0.92) 0%, rgba(10,12,16,0.3) 100%)' }} />
                <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 4, background: 'linear-gradient(90deg, #F5A623, #2EC4A0)' }} />
                <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', padding: '0 28px' }}>
                  <div>
                    <div style={{ fontSize: 9, color: '#F5A623', textTransform: 'uppercase', letterSpacing: 3, marginBottom: 8, fontWeight: 800 }}>Tips</div>
                    <div style={{ fontSize: 22, fontWeight: 900, marginBottom: 8, fontFamily: 'Impact, Haettenschweiler, sans-serif', textTransform: 'uppercase', letterSpacing: -0.5 }}>Spar med AutoPASS</div>
                    <p style={{ fontSize: 12, color: '#999', lineHeight: 1.65, margin: 0, maxWidth: 300, fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>Med AutoPASS-brikke får du automatisk alle rabatter og slipper å stoppe i bommen.</p>
                  </div>
                </div>
              </div>
              <div style={{ background: '#111520', border: '1px solid rgba(255,255,255,0.06)', padding: 28, position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: -10, right: -5, fontSize: 100, fontFamily: 'Impact, sans-serif', fontWeight: 900, color: 'rgba(46,196,160,0.04)', lineHeight: 1, userSelect: 'none' }}>i</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
                  <div style={{ width: 2, height: 16, background: '#2EC4A0' }} />
                  <span style={{ fontSize: 12, fontWeight: 900, fontFamily: 'Impact, sans-serif', letterSpacing: 1, textTransform: 'uppercase', color: '#2EC4A0' }}>Om beregningen</span>
                </div>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {[
                    'Oppdaterte takster fra alle norske bomstasjoner',
                    'EL-rabatt 50% og hybrid-rabatt 20% der tilgjengelig',
                    'Rushtidspriser 06:30–09:00 og 15:00–17:00',
                    'Kollektivfeltrabatt for 3+ passasjerer',
                    'Sesongvariasjon og helligdagsregler inkludert'
                  ]?.map((item, i) =>
                    <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 12, color: '#888' }}>
                      <div style={{ width: 14, height: 14, flexShrink: 0, marginTop: 1 }}><CheckIcon /></div>
                      {item}
                    </li>
                  )}
                </ul>
                <div style={{ marginTop: 16, paddingTop: 14, borderTop: '1px solid rgba(255,255,255,0.05)', fontSize: 10, color: '#444', fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>
                  Faktiske kostnader kan variere. Kontakt bompengeoperatøren for eksakte priser.
                </div>
              </div>
            </div>
          </section>

        </div>

        <QuickActionMenu />
        <AddVehicleModal
          isOpen={isAddVehicleModalOpen}
          onClose={() => setIsAddVehicleModalOpen(false)}
          onSave={() => setIsAddVehicleModalOpen(false)}
        />

        <style>{`
          @keyframes spin { to { transform: rotate(360deg); } }
          @keyframes slideIn { from { width: 0; } to { width: 100%; } }
        `}</style>
      </div>
    </>
  );
};

export default TollCalculator;